module.exports = "/_next/static/images/ht-9012459fcbfce7d7f99b7e2a3d6cd064.svg";